export enum MANIFEST_STATUSES {
  DRAFT = 'draft',
  GENERATING = 'generating',
  PENDING = 'pending',
  ACTIVE = 'active',
  ERRORED = 'errored',
}

export default MANIFEST_STATUSES;

